import { useSelector } from '../../../../store'
import {
  FlyoutOnboardingSectionName,
  type MicrosoftOnboarding,
  type Sections,
} from '../../../../modules/flyOutOnboarding/types'

export const useFlyOutOnboardingStatus = () => {
  const microsoftOnboardingValues = useSelector<MicrosoftOnboarding>(
    state => state.flyOutOnboarding.microsoftOnboardingForm
  )
  const awsOnboardingValues = useSelector<Sections>(
    state => state.flyOutOnboarding.onboardingForm
  )
  const isAwsOnboardingComplete = useSelector<boolean>(
    state => state.flyoutSellerInfo?.onboarded === true
  )
  const isMicrosoftOnboardingComplete = useSelector<boolean>(
    state => state.flyOutSellerInfoMicrosoft?.onboarded === true
  )

  const _isNewCompanyInfoComplete = microsoftOnboardingValues?.filledCompanyInfo

  const _isOldAwsCompanyInfoComplete =
    awsOnboardingValues?.[FlyoutOnboardingSectionName.PAGE_MARKER]?.page1

  const isCompanyInfoComplete =
    _isNewCompanyInfoComplete || _isOldAwsCompanyInfoComplete

  const onboardingComplete =
    isAwsOnboardingComplete || isMicrosoftOnboardingComplete

  return {
    isCompanyInfoComplete,
    onboardingComplete,
  }
}
